import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isMobile } from '../../utils/deviceInfo';
import {staticTitles} from '../../utils/constants'
import * as actionCreators from '../../modules/actions/index';
import { Link } from 'react-router-dom';
// import {NavBarLogo,Logo} from './../../components/Logo/Logo';
import Logo from './../../components/Logo/Logo';

import './../../components/NavBar/NavBar.css';
import {
  Navbar,
  NavItem,Nav,UncontrolledDropdown,DropdownToggle,DropdownMenu,
  NavbarToggler,
  NavbarBrand } from 'reactstrap';
import If from '../../components/Shared/If';


class OfficeSetupNavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  handleLogout = () =>{
    this.props.onLogoutSuccess();
    this.props.history.push('/');
 }

 navigateTo = (route) => {
  this.props.history.push(route);
}

  render() {
    const {firstName,lastName,officeId, isProfileDetailsUpdated} = this.props.user.profile;
    let {isSetupSkipped, name} = this.props.user.profile.organizationId
    return (
      <Navbar light expand="md" fixed="top"
        role="navigation" className="top-navbar-bg">
        <NavbarBrand href="" className="d-flex align-items-center">
        <Logo/>
        <If condition={!isMobile}>
        <span style={{marginLeft: '5px',color:'#333333',fontSize:'16px',marginTop:'5px'}}>
          at {officeId && officeId.name ? officeId.name : name?name:''}</span>
        </If>
        </NavbarBrand>
        <If condition={!isMobile}>
          <NavbarToggler onClick={this.toggle} />
          <Nav className='ml-auto' navbar>
          <UncontrolledDropdown nav inNavbar>
            <DropdownToggle nav>
              {
                firstName && lastName ?
                `${firstName} ${lastName}` : 'Welcome'
              }
              <i style={{color: '#818391', height: '21px', width: '21px',marginLeft: '10px'}}
                className="flaticon-download"></i>
            </DropdownToggle>
            <DropdownMenu right
              style={{background:'#969696',border:'none',
                boxShadow: '3px 4px 4px rgba(0, 0, 0, 0.25)',borderRadius: '4px', padding: '0'}}>

              {isSetupSkipped && isProfileDetailsUpdated?
              <div className="top-dd-option" onClick={()=> this.navigateTo('/home/stories')}>Back to {staticTitles.stories}</div>
              :
             null
              }
               <div className="top-dd-option" onClick={()=> this.handleLogout()}>Sign Out</div>

            </DropdownMenu>
          </UncontrolledDropdown>
          </Nav>
        </If>
      </Navbar>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user : state.user
  }
}

const mapDispatchToProps = dispatch => {
	return {
		onLogoutSuccess: (data) => dispatch(actionCreators.logout())
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(OfficeSetupNavBar);
